<template>
  <div class="contact">
    <h2>联系我们</h2>
    <p></p>
    <div class="content">
      <div class="map">
        <img src="../../static/images/map.png" alt="">
      </div>
      
      <div class="contact-box">
        <div class="contact-item" @mouseenter="onmouseenter('huizhou')">
          <div class="title">惠州一匠科技有限公司</div>
          <div class="item">
            <img src="../../static/images/about/youxiang.png" />
            <p>地址：惠城区四环南路3号读者文化园 E座1204</p>
          </div>
        </div>
        <!-- <div class="contact-item" @mouseenter="onmouseenter('guangzhou')">
          <div class="title">广东一匠科技有限公司</div>
          <div class="item">
            <img src="../../static/images/about/youxiang.png" />
            <p>地址：广东省广州市天河区荷光路137号三楼</p>
          </div>
        </div> -->
        <div class="second-style">
          <img src="../../static/images/about/dianhua.png" />
          <div class="info">
            <div class="name">联系电话</div>
            <div class="txt">13824289487</div>
          </div>
        </div>
        <div class="second-style">
          <img src="../../static/images/about/youxiang2.png" />
          <div class="info">
            <div class="name">邮箱</div>
            <div class="txt">eartisan@163.com</div>
          </div>
        </div>
        <!-- <div class="btn" @click="jumpService">咨询合作</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFrist:true
    };
  },
  methods: {
    jumpService() {
      this.$addConsult()
    },
    onmouseenter(type){
      if(type=='huizhou'){
        this.showFrist = true;
      }else{
        this.showFrist = false;
      }
    }
  },
};
</script>

<style  lang="stylus" scoped>
.contact-box {
  display: flex;
  flex-wrap: wrap;
  margin-left: 26px;
}

.contact-item, .second-style {
  width: 450px;
  height: 185px;
  background: #FFFFFF;
  box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
  border-radius: 4px;
  padding: 40px;
  box-sizing: border-box;
  margin-right: 24px;
  margin-bottom: 24px;

  .title {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 28px;
  }
}

.second-style {
  display: flex;

  img {
    width: 78px;
    height: 78px;
  }

  .info {
    margin-left: 24px;
  }

  .name {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
  }

  .txt {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-top: 22px;
  }
}

.contact {
  .content {
    display: flex;
    justify-content:center;
    margin: 52px auto 132px auto;
    min-width: 1440px;
    .contact-box{
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }

  h2 {
    text-align: center;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    letter-spacing: 2px;
  }

  >p:first-of-type {
    border-bottom: 1px solid #F5BA1A;
    margin: 24px auto 0;
    width: 42px;
    height: 2px;
  }

  .box {
    padding: 40px;
    box-sizing: border-box;
    width: 496px;
    height: 420px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    border-radius: 4px;
    margin-left: 24px;

    .title {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      margin-bottom: 60px;
    }
  }

  .item {
    display: flex;
    align-items: flex-start;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 34px;
    margin-top: 34px;

    img {
      margin-right: 17px;
      margin-top: 10px;
    }
  }

  .btn {
    line-height: 40px;
    text-align: center;
    width: 100px;
    height: 40px;
    background: #FFC000;
    border-radius: 4px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 60px;
  }

  .map {
   width 450px
   height 418px
   img{
    width 100%
    height 100%
   }
  }
  .map-guangzhou {
    background: url('../../static/images/about/ditu2.png') no-repeat center center;
    .bubble {
        background: url('../../static/images/about/qitao2.png') no-repeat center center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/AboutContact.vue